<mat-menu #userMenu="matMenu" xPosition="before" class="menu-container pt-24 pb-16 pr-24 pl-24">
  <div class="flex">
    <div class="mr-8">
      <div class="avatar-circle avatar-lg">{{principalAbbreviation}}</div>
    </div>
    <div>
      <div class="mat-subtitle-2 mb-0 fw-700 fs-20">{{principal?.attributes?.name | titlecase}}</div>
      <div class="email">{{principal?.attributes?.email}}</div>
    </div>
  </div>
  <mat-divider class="neutral-2 mb-16 mt-16"></mat-divider>
  <div *ngIf="isTenantView" class="flex cursor-pointer" (click)="goToMyAccount()">
    <mat-icon svgIcon="account_circle" class="icon-md"></mat-icon><span class="ml-8 fw-500">{{'MY_ACCOUNT.MY_ACCOUNT' | transloco}}</span>
  </div>
  <div class="flex pt-16 logout cursor-pointer" (click)="logout()">
    <mat-icon svgIcon="logout" class="icon-md"></mat-icon><span class="ml-8 fw-500">{{'MY_ACCOUNT.LOGOUT' | transloco}}</span>
  </div>
</mat-menu>

<div class="flex flex-row justify-center items-center">
  <button [matMenuTriggerFor]="userMenu" mat-button class="account-color">
    <div class="flex flex-row justify-center items-center arrow-icon">
      <div class="avatar-circle avatar-sm">{{principalAbbreviation}}</div>
    </div>
  </button>
</div>